import React from 'react';
import { User } from 'lucide-react';

const MenteeDetailsWidget = () => {
  return (
    <div className="text-center py-8">
      <User className="w-12 h-12 mx-auto mb-3 text-gray-300" />
      <p className="text-gray-600">Select a mentee from the list to view details</p>
    </div>
  );
};

export default MenteeDetailsWidget;